import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-6",
  fill: "none",
  viewBox: "0 0 512 512",
  stroke: "currentColor",
  "stroke-width": "2",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#dc2626",
    d: "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
  })
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "fixed bottom-24 right-5 max-w-xs p-4 bg-white rounded-lg shadow-2xl z-[100000] before:content-[''] before:absolute before:-bottom-3 before:right-6 before:border-t-[19px] before:border-t-white before:border-x-[10px] before:border-x-transparent"
}

import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  props: {
    description: null
  },
  setup(__props: any) {

const props = __props as {
    description: string
}



const isTextVisible = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isTextVisible.value = !isTextVisible.value)),
      class: "fixed bottom-5 right-5 p-4 bg-curaduriaDark rounded-full text-white cursor-pointer shadow-lg z-50"
    }, _hoisted_2),
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity duration-300",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition-opacity duration-300",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (isTextVisible.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(props.description), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})